import { Box, Spinner } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { Placeholder } from '#modules/user/features/dashboard';

/**
 * Показывается вместо экрана ошибки в единственном случае: у человека открыта вкладка со старой
 * сборкой, её чанки после релиза уже удалены с сервера, и мы прямо сейчас перезагружаем страницу.
 * Для него это не поломка, а обновление — см. DefaultCatchBoundary.
 *
 * Тексты здесь — обычные фразы, а не коды вида `common:appUpdating.title`, и это не стиль,
 * а требование к этому экрану. Каталог переводов приезжает динамическим импортом
 * (features/i18n/utils/index.ts), то есть отдельным чанком — тем же, что умирает при выкате
 * вместе с остальными. Оставшись без словаря, Lingui подставляет вместо текста идентификатор,
 * и человек читал «common:appUpdating.title» ровно в тот момент, когда мы объясняем ему, что
 * всё в порядке. С фразой в качестве идентификатора худший случай — английский текст.
 */
export const UpdateInProgress = () => {
  const { t } = useLingui();

  return (
    <Box w="100%">
      <Placeholder icon={<Spinner size="xl" color="brand.500" borderWidth="3px" />}>
        <Placeholder.Title>{t`A new version is out`}</Placeholder.Title>
        <Placeholder.Description>{t`Loading it right now…`}</Placeholder.Description>
      </Placeholder>
    </Box>
  );
};
